import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-device",
  "use": "icon-leo-e1-device-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-device\">\r\n<g transform=\"translate(-17.329 -17.329) scale(1.033846)\">\r\n<path d=\"M160 192h448a64 64 0 0 1 64 64v512a64 64 0 0 1-64 64H160a64 64 0 0 1-64-64V256a64 64 0 0 1 64-64zm64 128v64h320v-64H224zm0 160v64h224v-64H224zm0 160v64h288v-64H224z\" />\r\n  <path d=\"M704 352h160a64 64 0 0 1 64 64v256a64 64 0 0 1-64 64H704V352zm48 112v48h64v-48h-64zm0 96v48h64v-48h-64z\" />\r\n  <path d=\"M768 288h32v64h-32V288zm0 448h32v64h-32v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-device.svg
// module id = 6ij2
// module chunks = 477